import { render, staticRenderFns } from "./Purchasing.vue?vue&type=template&id=281a8a79&"
import script from "./Purchasing.vue?vue&type=script&lang=js&"
export * from "./Purchasing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports